<ng-container *transloco="let tr; prefix: 'workflows'; scope: 'workflows'">
  <nz-affix [nzOffsetTop]="0">
    <hx-breadcrumbs></hx-breadcrumbs>
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{tr('stepTitle')}}</nz-page-header-title>
      <nz-page-header-subtitle>{{tr('stepSubTitle')}}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <a routerLink="new" nz-button nzType="primary">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'button.addNew' | transloco}}
        </a>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>

  <nz-table [nzLoading]="isTableLoading" #listTable
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th>{{tr('column.order')}}</th>
      <th>
        <a >{{tr('column.title')}}</a>
      </th>
      <th>{{tr('column.description')}}</th>
      <th>{{tr('column.workflow')}}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of listTable.data">
      <td>
        {{ data.order }}
      </td>
      <td>
        <a [routerLink]="data.id + '/recipes'">
          {{ data.title | uiLabel }}
        </a>
      </td>
      <td>
        <div [innerHTML]="data.description | safeHtml"></div>
      </td>
      <td>
        {{ data.workflow.title | uiLabel }}
      </td>
      <td>
        <nz-button-group>
          <a [routerLink]="data.id + '/edit'" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </a>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data.id)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>
</ng-container>
